import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchOpdracht } from '../services/fetchOpdracht'

export { useOpdracht }

const queryKey = 'opdracht'

const useOpdracht = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryFn: () => fetchOpdracht(id),
    queryKey: [queryKey, id],
    enabled: hasPermissions && !!id,
  })

  return {
    data,
    isLoading,
    isError,
  }
}
